import { Injectable } from '@angular/core';
import { EligibleExam } from '../../../practitioner/shared/models/eligibleExam';
import { ICredential } from '../../../shared/models/credential';
import { Profile } from '../../../practitioner/shared/models/profile';
import { ActiveDirectorySearch } from '../../../directory/shared/models/activeSearch';
import { Course } from './../../../practitioner/shared/models/course';
import { IHorizon } from './../../../horizons/shared/horizon';
import { IPurchaseHistory } from './../../../practitioner/shared/models/purchaseHistory';
import { IPurchaseDetail } from './../../../practitioner/shared/models/purchaseDetail';

const examData = [
  {
    'examID': 698,
    'personID': 270602,
    'examCode': 'CRT',
    'examName': 'Neonatal/Pediatric Respiratory Care Specialty Examination',
    'iconLink': '',
    'applicationStatus': 'N5',
    'eligibilityEndDate': null,
    'reinstatementFee': 'false',
    'collectBirthday': false,
    'collectDiscipline': false,
    'collectDemographics': false,
    'isSubjectToDisciplineAudit': false,
    'cost': null
  },
  {
    'examID': 699,
    'personID': 270602,
    'examCode': 'CRT',
    'examName': 'Credential Exam Name ',
    'iconLink': '',
    'applicationStatus': 'N5',
    'eligibilityEndDate': '2019-01-31T00:00:00',
    'reinstatementFee': '',
    'collectBirthday': false,
    'collectDiscipline': false,
    'collectDemographics': false,
    'isSubjectToDisciplineAudit': false,
    'cost':null
  }
];

const horizonsList = [
  {
    'id': 232,
    'fileName': '2017 NBRC Horizons 2nd Quarter.pdf',
    'size': 2696274,
    'publishDate': '2017-05-26T00:00:00'
  },
  {
    'id': 230,
    'fileName': '2017 NBRC Horizons 1st Quarter.pdf',
    'size': 874900,
    'publishDate': '2017-02-21T00:00:00'
  },
  {
    'id': 234,
    'fileName': '2017 NBRC Horizons 3.pdf',
    'size': 2696274,
    'publishDate': '2017-05-26T00:00:00'
  },
  {
    'id': 236,
    'fileName': '2017 NBRC Horizons 4.pdf',
    'size': 874900,
    'publishDate': '2017-03-21T00:00:00'
  },
  {
    'id': 238,
    'fileName': '2017 NBRC Horizons 5.pdf',
    'size': 2696274,
    'publishDate': '2017-04-26T00:00:00'
  },
  {
    'id': 240,
    'fileName': '2017 NBRC Horizons 6.pdf',
    'size': 874900,
    'publishDate': '2017-01-21T00:00:00'
  }
]

const purchaseHistory = [
  {
    'id': 1111100,
    'serviceTransactionDate': '2014-01-23T00:00:00',
    'chargeDetail': [
      {
        'codeDescription': 'CREDENTIAL VERIFICATION',
        'renewalYear': ''
      }
    ],
    'totalCost': 10
  },
  {
    'id': 1228413,
    'serviceTransactionDate': '2015-02-13T00:00:00',
    'chargeDetail': [
      {
        'codeDescription': 'RENEWAL FEE',
        'renewalYear': '2015'
      }
    ],
    'totalCost': 25
  },
  {
    'id': 1310368,
    'serviceTransactionDate': '2015-12-10T00:00:00',
    'chargeDetail': [
      {
        'codeDescription': 'RENEWAL FEE',
        'renewalYear': '2016'
      }
    ],
    'totalCost': 25
  },
  {
    'id': 1386929,
    'serviceTransactionDate': '2016-10-05T00:00:00',
    'chargeDetail': [
      {
        'codeDescription': 'ONLINE RENEWAL FEE',
        'renewalYear': '2017'
      }
    ],
    'totalCost': 20
  },
  {
    'id': 1557301,
    'serviceTransactionDate': '2013-12-30T00:00:00',
    'chargeDetail': [],
    'totalCost': 190
  },
  {
    'id': 1557302,
    'serviceTransactionDate': '2014-01-13T00:00:00',
    'chargeDetail': [],
    'totalCost': 340
  },
  {
    'id': 1557303,
    'serviceTransactionDate': '2014-01-21T00:00:00',
    'chargeDetail': [],
    'totalCost': 200
  }
]

const purchaseDetail = {
  'payments': [
    {
      'badPayments': [],
      'id': 431747,
      'serviceChargeID': 1228413,
      'paymentMethod': 'Credit Card',
      'paymentAmount': 25,
      'ccTransactionID': 646082,
      'referenceCode': null,
      'payerName': 'John Smith',
      'paymentDate': new Date('02/13/2015'), // '2015-02-13T00:00:00',
      'createdBy': 'JODYB',
      'createdDate': '2015-02-13T15:26:41',
      'modifiedBy': 'JODYB',
      'modifiedDate': '2015-02-13T15:26:41',
      'rowVersion': 'AAAAAAHqBLQ='
    }
  ],
  'serviceChargeDetails': [
    {
      'serviceCode': {
        'id': 14,
        'code': 'F02',
        'codeDescription': 'RENEWAL FEE',
        'activeRate': 25,
        'inactiveRate': 25,
        'credentialCode': null,
        'beginDate': '2003-10-16T00:00:00',
        'endDate': null,
        'pickTicketFlag': null,
        'taxable': false
      },
      'id': 481982,
      'serviceChargeID': 1228413,
      'serviceCodeID': 14,
      'quantity': 1,
      'pinInitials': null,
      'cost': 25,
      'createdBy': 'JODYB',
      'createdDate': '2015-02-13T15:26:41',
      'modifiedBy': 'JODYB',
      'modifiedDate': '2015-02-13T15:26:41',
      'renewalYear': '2015'

    }
  ],
  'id': 1228413,
  'personId': 270602,
  'serviceTransactionDate': '2015-02-13T00:00:00',
  'totalCost': 25,
  'salesTax': null,
  'batchNumber': '15-218',
  'comments': 'AUTOGENERATED renewal 2015',
  'createdBy': 'JODYB',
  'createdDate': '2015-02-13T15:26:41',
  'modifiedBy': 'JODYB',
  'modifiedDate': '2015-02-13T15:26:41',
  'rowVersion': 'AAAAAAHgce4='
}

const email = {
  'id': 151370,
  'personID': 270602,
  'emailType': 0,
  'email': 'shelley@houseofhecht.com',
  'optOut': false,
  'badAddress': null,
  'createdBy': 'JODYB',
  'createdDate': '2014-01-10T08:52:06',
  'modifiedBy': 'WebUser',
  'modifiedDate': '2017-07-21T15:01:27.733',
  'rowVersion': 'AAAAAAIBq7M='
};

const address = {
  'country': {
    'id': 1,
    'countryCode': 'USA',
    'countryName': 'UNITED STATES OF AMERICA',
    'isoCountryCode': 'US',
    'isoCountryName': 'UNITED STATES',
    'isoCurrencyCode': 'USD',
    'isoCurrencyName': 'US Dollar',
    'isoCountryCode3': 'USA',
    'createdBy': null,
    'createdDate': null,
    'modifiedBy': null,
    'modifiedDate': null,
    'rowVersion': 'AAAAAAGbJWY='
  },
  'id': 183559,
  'personID': 270602,
  'addressType': 0,
  'line1': '1211 No Park',
  'line2': null,
  'line3': null,
  'city': 'Kansas City',
  'zip': '66209',
  'zipPlus4': null,
  'countryID': 1,
  'stateProvince': 'KS',
  'badAddress': null,
  'createdBy': 'JODYB',
  'createdDate': '2014-01-10T08:52:06',
  'modifiedBy': 'WebUser',
  'modifiedDate': '2017-07-21T15:58:19.317',
  'rowVersion': 'AAAAAAIBq8Y='
}

const credentials = [
  {
    'credential': 'CRT',
    'certificationDate': '2014-01-09T00:00:00',
    'expirationDate': '2019-01-31T00:00:00',
    'renewalType': 'NC',
    'registryNumber': null,
    'baseCredential': 'RRT'
  },
  {
    'credential': 'RRT',
    'certificationDate': '2014-01-30T00:00:00',
    'expirationDate': '2019-01-31T00:00:00',
    'renewalType': 'NC',
    'registryNumber': 140817,
    'baseCredential': 'RRT'
  }
]

const membershipStatus = [
  {
    'id': 0,
    'personID': 270602,
    'status': 'I',
    'beginDate': null,
    'endDate': null,
    'createdBy': null,
    'createdDate': null,
    'modifiedBy': null,
    'modifiedDate': null,
    'rowVersion': null
  }
]

const courseCompletions = [
  {
    'courseCategory': {
      'id': 1,
      'category': 'Lecture'
    },
    'courseUsageType': {
      'id': 2,
      'courseTypeCode': 'GRESP',
      'courseTypeDescription': 'General Respiratory Care ',
      'createdBy': null,
      'createdDate': null,
      'modifiedBy': null,
      'modifiedDate': null,
      'requirementDue': 'CE'
    },

    'id': 1333622,
    'courseCode': null,
    'courseName': 'Case Studies in Non-Invasive Ventilation: After Patient Selection',
    'courseHours': 1,
    'courseCategoryId': 1,
    'personID': 270602,
    'import': true,
    'courseUsageTypeId': 1,
    'enrollmentDate': '2017-07-12T00:00:00',
    'completionDate': '2017-07-12T00:00:00',
    'auditedDate': null,
    'createdBy': 'AARCSERVICE',
    'createdDate': '2017-07-14T03:19:33.94',
    'modifiedBy': null,
    'modifiedDate': null
  },
  {
    'courseCategory': {
      'id': 1,
      'category': 'Lecture'
    },
    'courseUsageType': {
      'id': 2,
      'courseTypeCode': 'GRESP',
      'courseTypeDescription': 'General Respiratory Care ',
      'createdBy': null,
      'createdDate': null,
      'modifiedBy': null,
      'modifiedDate': null,
      'requirementDue': 'CE'
    },

    'id': 1333598,
    'courseCode': null,
    'courseName': 'How about Pediatric ARDS: Do We Have Consensus? ',
    'courseHours': 2,
    'courseCategoryId': 1,
    'personID': 270602,
    'import': true,
    'courseUsageTypeId': 3,
    'enrollmentDate': '2017-06-22T00:00:00',
    'completionDate': '2017-06-22T00:00:00',
    'auditedDate': null,
    'createdBy': 'AARCSERVICE',
    'createdDate': '2017-06-28T19:33:54.157',
    'modifiedBy': null,
    'modifiedDate': null
  },
  {
    'courseCategory': {
      'id': 2,
      'category': 'Panel'
    },
    'courseUsageType': {
      'id': 1,
      'courseTypeCode': 'ACCS',
      'courseTypeDescription': 'ACCS',
      'createdBy': null,
      'createdDate': null,
      'modifiedBy': null,
      'modifiedDate': null,
      'requirementDue': 'CE'
    },

    'id': 1333620,
    'courseCode': null,
    'courseName': 'Live Internet Respiratory Lectures June 2017 // Adult History and Physical Assessment',
    'courseHours': 1,
    'courseCategoryId': 1,
    'personID': 270602,
    'import': true,
    'courseUsageTypeId': 2,
    'enrollmentDate': '2017-06-01T00:00:00',
    'completionDate': '2017-06-01T00:00:00',
    'auditedDate': null,
    'createdBy': 'AARCSERVICE',
    'createdDate': '2017-07-14T03:19:33.517',
    'modifiedBy': null,
    'modifiedDate': null
  }
]

const ccpHoursRequired = [
  {
    'id': 270602,
    'personID': 270602,
    'expirationDate': '2019-01-31T00:00:00',
    'credentialsHeld': 'RRT',
    'applicationType': 'RRT',
    'greHours': 30,
    'neoHours': 0,
    'pftHours': 0,
    'accsHours': 0,
    'sdsHours': 0
  }
]

const renewalInfo = [
    {
        'personID': 270602,
        'renewalYear': 2018,
        'activeID': 16,
        'supporterID': 17,
        'cost': 20
    }
]

const practitionerData = {
  'id': '270602',
  'ssn': '951256874',
  'firstName': 'SHELLEY',
  'middleName': 'A',
  'lastName': 'HECHT',
  'suffix': null,
  'directoryStatus': null,
  'birthday': '1973-05-11T00:00:00',
  'email': 'test@test.com',
  'homePhone': '913-556-9815',
  'workPhone': null,
  'cellPhone': '846-265-8855',
  'status': 'S',
  'showRenewal': true,
  'showCCP': true,
  'showRecert': false,
  'showReinstate': false,
  'underAudit': false,
  'underNBRCJE': false,
  'credentialHolder': true,
  'ccpCycleBegin': '2014-02-01T00:00:00',
  'ccpCycleEnd': '2019-01-31T00:00:00',
  'expiredCredentials': false,
  'badAddress': false
}

const ccpData = {
  'feeDue': 0,
  'renewalStatus': 'Not enough hours',
  'activeYears': 0,
  'recertify': false,
  'reinstate': false,
  'beginDate': '2017-05-31T00:00:00',
  'expirationDate': '2022-05-31T00:00:00',
  'appType': 'CRT',
  'personID': 208682,
  'flagForAudit': false,
  'ccpHoursRequired': [
    {
      'id': 270602,
      'personID': 270602,
      'expirationDate': '2019-01-31T00:00:00',
      'credentialsHeld': 'RRT',
      'applicationType': 'RRT',
      'greHours': 30,
      'neoHours': 12,
      'pftHours': 5,
      'accsHours': 0,
      'sdsHours': 4
    }
  ]
}

const practitionerCourseData = {
  'id': 1333401,
  'courseCode': null,
  'courseName': 'January 2017 RESPIRATORY CARE JournalCast',
  'courseHours': 1,
  'categoryID': 1,
  'personID': 270602,
  'import': true,
  'courseUsageTypeID': 2,
  'enrollmentDate': '2017-01-20T00:00:00',
  'completionDate': '2017-01-20T00:00:00',
  'auditedDate': null,
  'createdBy': 'AARCSERVICE',
  'createdDate': '2017-06-20T15:25:31.0954047-05:00',
  'modifiedBy': null,
  'modifiedDate': null
}

const creditCardPaymentData = {
  'feeDue': 0,
  'renewalStatus': 'Not enough hours',
  'activeYears': 0,
  'recertify': false,
  'reinstate': false,
  'beginDate': '2017-05-31T00:00:00',
  'expirationDate': '2022-05-31T00:00:00',
  'appType': 'CRT',
  'personID': 208682,
  'flagForAudit': false
}

const examApplication = {
  'examID': 698,
  'personId': 270602,
  'examCode': 'NPS',
  'examName': 'Neonatal/Pediatric Respiratory Care Specialty Examination',
  'iconLink': null,
  'applicationId': '164923',
  'applicationStatus': 'ELIG',
  'applicationStatusCode': 'N1',
  'serviceCodeId': 70,
  'cost': 250,
  'eligibilityBeginDate': '2017-08-02T00:00:00',
  'eligibilityEndDate': '2017-10-31T00:00:00'
}

const examPurchase = {
  'serviceChargeId': 1952732,
  'paymentDate': '2017-08-03T13:33:57.2940111-05:00',
  'scheduleingLink':
    'https://online.goamp.com/CandidateHome/Login.aspx?ReturnUrl=%2fCandidateHome%2fOnlineApplication.aspx%3fpExamID%3d51&pExamID=51',
  'authCode': 'F99R11'
}

const profileData = {
  'personId': 123,
  'firstName': 'John',
  'middleName': 'J',
  'lastName': 'Doe',
  'suffix': 'Jr.',
  'ssn': '12345789',
  'line1': '1234 Mockingbird Lane',
  'line2': 'Line 2',
  'line3': 'Line 3',
  'email': 'test@test.com',
  'emailOptIn': true,
  'gender': 'MALE',
  'address1': '123 Main St',
  'address2': 'Apt. 23',
  'city': 'Cityville',
  'stateProvince': 'KS',
  'zip': '65498',
  'zipPlus4': null,
  'homePhone': '123489748',
  'cellPhone': '321321325',
  'workPhone': null,
  'smsOptIn': false,
  'cmpOptIn': false,
  'cmpOptOut': false,
  'badAddress': false,
  'birthday': '1990-07-01T00:00:00',
  'countryId': 1,
  'directoryStatus': 'N',
  'emailOptOut': false,
  'underNBRCJE': false,
  'ccpCycleBegin': null,
  'ccpCycleEnd': null,
  'ccpStatus': null,
  'status': null,
  'badPayment': null,
  'contactNBRC': null,
  'cmpDashBoard': false,
  'allowCmpOptInOrOut': false,
  'scheduledExams': false,
  'showBadge': false,
  'badEmail' : false,
  'reviewProfile' : false,
  'reviewDemographics': false
}

@Injectable()
export class PractitionerMocksService {
  credentials: ICredential[] = credentials;
  exams: EligibleExam[] = examData;
  horizonsList: IHorizon[] = horizonsList;
  purchaseHistory: IPurchaseHistory[] = purchaseHistory;
  purchaseDetail: IPurchaseDetail = purchaseDetail;
  ccpData = ccpData;
  courses = practitionerCourseData;
  paymentResponse = creditCardPaymentData;
  profile: Profile = profileData;
  renewalInfo = renewalInfo;

  constructor() { }

  submitCCPayment(): any {
    return ({ body: this.paymentResponse, status: 200, headers: null, url: '', merge: null });
  }

  getCCPInfo(): any {
    return ({ body: this.ccpData, status: 200, headers: null, url: '', merge: null });
  }

  getCredentialsAndExams(): any {
    const responseBody = {
      creds: this.credentials,
      exams: this.exams
    }
    return ({ body: responseBody, status: 200, headers: null, url: '', merge: null });
  }

  getExamApplication(): any {
    return ({ body: examApplication, status: 200, headers: null, url: '', merge: null });
  }

  getExamPurchase(): any {
    return ({ body: examPurchase, status: 200, headers: null, url: '', merge: null });
  }

  getHorizonsList(): any {
    return ({ body: this.horizonsList, status: 200, headers: null, url: '', merge: null });
  }

  getPurchaseHistory(): any {
    return ({ body: this.purchaseHistory, status: 200, headers: null, url: '', merge: null });
  }

  getPurchaseDetail(): any {
    return ({ body: this.purchaseDetail, status: 200, headers: null, url: '', merge: null });
  }

  addCourse(): any {
    return ({ body: this.courses, status: 201, headers: null, url: '', merge: null });
  }

  deleteCourse(): any {
    return ({ body: {}, status: 201, headers: null, url: '', merge: null });
  }

  importCourse(): any {
    return ({ body: this.courses, status: 200, headers: null, url: '', merge: null });
  }

  updateProfile(): any {
    return ({ body: { 'success': true }, status: 200, headers: null, url: '', merge: null });
  }

  updateDemographics(): any {
    return ({ body: { 'success': true }, status: 200, headers: null, url: '', merge: null });
  }

  getRenewalInfo(): any {
    return ({ body: this.renewalInfo, status: 200, headers: null, url: '', merge: null });
  }
}
